<!--
  One row of the transaction notification settings modal: title and description on the left,
  the control (button, switch) on the right. Rows stack with a divider between them.
-->
<template>
  <div class="setting-row">
    <div>
      <div class="fw-semibold text-body-emphasis">
        <slot name="title"></slot>
      </div>
      <div class="setting-row__description fs-9 text-body-tertiary mt-1">
        <slot name="description"></slot>
      </div>
    </div>
    <div class="d-flex justify-content-end"><slot name="control"></slot></div>
  </div>
</template>

<style scoped lang="scss">
.setting-row {
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 1.5rem;
  align-items: center;
  padding: 1.25rem 0;

  & + & {
    border-top: 1px solid var(--phoenix-border-color-translucent);
  }
}

.setting-row__description {
  :deep(p) {
    margin-bottom: 0;
  }

  :deep(p + p) {
    margin-top: 0.25rem;
  }

  :deep(.alert) {
    margin-bottom: 0;
  }
}
</style>
